import { render, staticRenderFns } from "./OtherReport.vue?vue&type=template&id=654a8243"
import script from "./OtherReport.vue?vue&type=script&lang=js"
export * from "./OtherReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports